import React from 'react';
import { Link } from 'react-router-dom';
import { FiX } from 'react-icons/fi';
import { useCompare } from '../context/CompareContext';

const CompareBar = () => {
  const { compareList, removeFromCompare, clearCompare, compareCount } = useCompare();

  if (compareCount === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 text-white border-t border-gray-700 shadow-lg">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0 overflow-x-auto">
          <span className="text-xs text-gray-400 uppercase tracking-wider flex-shrink-0">Compare ({compareCount}/3)</span>
          {compareList.map(shed => (
            <div key={shed.id} className="flex items-center gap-2 bg-gray-800 px-2.5 py-1.5 flex-shrink-0">
              <img
                src={shed.images?.[0] || '/assets/images/placeholder-shed.jpg'}
                alt={shed.name}
                className="w-8 h-8 object-cover"
              />
              <span className="text-sm truncate max-w-[120px]">{shed.name}</span>
              <button onClick={() => removeFromCompare(shed.id)} className="text-gray-400 hover:text-white ml-1">
                <FiX className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button onClick={clearCompare} className="text-xs text-gray-400 hover:text-white transition-colors">
            Clear
          </button>
          <Link
            to="/compare"
            className="bg-white text-gray-900 text-sm font-medium px-5 py-2 hover:bg-gray-100 transition-colors"
          >
            Compare Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
